import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaRegFile } from 'react-icons/fa';
import { useU2000AuthContext } from '../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000FormStateHandlers } from '../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import { U2000FormStateEnumState } from '../../../u2000Core/reducer/formReducer/U2000FormState';
import { NS, U2201ROLES } from '../../U2201';

interface U2201JobScheduleFormToolBarProps {
  formStateHandlers: U2000FormStateHandlers<Record<string, unknown>> & {
    getData: () => unknown;
    getFormState: () => U2000FormStateEnumState;
    modifyJobSchedule: () => void;
  };
}

export const U2201JobScheduleFormToolBar: React.FC<U2201JobScheduleFormToolBarProps> = ({
  formStateHandlers,
}) => {
  const formState = formStateHandlers.getFormState();
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U2201ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyJobSchedule();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
